module.exports = __webpack_public_path__ + "img/hwc_header.eff06e0c.jpg";